// ops / dto — the wire contract of the operator's Ops pages that are not
// feedback or AI usage: which deployment this is, and the accounts list.
// The zod schemas ARE the contract: the server answers with these shapes,
// the client parses them at its boundary (`@bilda/app/ops`). Browser-safe:
// zod only. Facts, never display text.
export { opsAccountsDto, opsEnvironmentDto };
import { z } from "zod";
// Which deployment answers (the Ops menu's marker). "unknown" (a local
// server) shows no marker.
const opsEnvironmentDto = z.object({
    environment: z.enum(["staging", "production", "unknown"]),
});
const opsAccountDto = z.object({
    id: z.string(),
    email: z.string(),
    createdAt: z.string(),
    // Set when an operator disabled the account (locked out).
    disabledAt: z.string().nullable(),
    workspaceId: z.string().nullable(),
    // The newest sign-in this server still holds a session for; null when
    // none is held (never signed in, signed out, or disabled since).
    lastSignInAt: z.string().nullable(),
    isAdmin: z.boolean(),
    // The AI cost billed to this account today (UTC), micro-USD (QA-14).
    aiSpentTodayMicroUsd: z.number().int().nonnegative(),
});
// Today's AI spend for the whole deployment, and both daily ceilings.
const opsAiTodayDto = z.object({
    deploymentMicroUsd: z.number().int().nonnegative(),
    accountCeilingMicroUsd: z.number().int().positive(),
    deploymentCeilingMicroUsd: z.number().int().positive(),
});
const opsAccountsDto = z.object({
    users: z.array(opsAccountDto),
    total: z.number().int().nonnegative(),
    aiToday: opsAiTodayDto,
    // The signed-in operator's own account id (no actions on that row).
    selfId: z.string().optional(),
});
//# sourceMappingURL=dto.js.map